module.exports = __webpack_public_path__ + "img/06-424-424.9478f79d.png";